import React from "react"
import { services } from "../data/dummydata"
import s from "../../styles/services.module.css"

export const Services = ({language}) => {
  return (
   
      <div className={s.services}>
      <h2  className={s.heading} data-aos='zoom-in-down'>
      {language!==false? "Skills": "Tecnologías"}
      </h2>
          <div className={s.container}>
            {services.map((item) => (
              <div key={item.id}  data-aos='flip-left'>
                <img src={item.image} alt={item.alt} className={s.icon} />
              </div>
            ))}
          </div>
        
      </div>
 
  )
}
